
import maplibregl from 'maplibre-gl';

export function initMap(config) {
    const map = new maplibregl.Map({
        container: 'map',
        style: config.style,
        center: config.chapters[0].location.center,
        zoom: config.chapters[0].location.zoom,
        bearing: config.chapters[0].location.bearing,
        pitch: config.chapters[0].location.pitch,
        // make storymap partially interactive
        interactive: true,
        dragPan: false,
        dragRotate: false,
        doubleClickZoom: false,
        scrollZoom: false,
        touchZoomRotate: false,
        maplibreLogo: true
    });

    // Enable prefetching of tiles at one zoom level above current
    map.prefetchZoomDelta = 1;

    return map;
}

